import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getTooltipClasses = ({ dsf_size, dsf_type }) => {
  const classes = [
    "font-sans relative flex flex-col gap-2 items-start justify-center rounded-sm p-8"
  ];
  classes.push(dsf_size === "small" ? "dsf-text-xxs" : "dsf-text-xs");
  if (dsf_type === "dark") {
    classes.push("bg-neutral-700 text-neutral-0");
  } else if (dsf_type === "secondary") {
    classes.push("bg-secondary-300 text-neutral-0");
  } else if (dsf_type === "outlined") {
    classes.push("bg-neutral-0 text-neutral-700 border border-neutral-200");
  }
  return concatClasses(classes);
};
const updateCSSVariables = (tooltip) => {
  if (tooltip.dsf_type === "secondary") {
    tooltip.style.setProperty("--dsf-arrow-border-color", "rgba(var(--dsf-color-secondary-300))");
    tooltip.style.setProperty("--dsf-arrow-color", "rgba(var(--dsf-color-secondary-300))");
  } else if (tooltip.dsf_type === "outlined") {
    tooltip.style.setProperty("--dsf-arrow-border-color", "rgba(var(--dsf-color-neutral-200))");
    tooltip.style.setProperty("--dsf-arrow-color", "rgba(var(--dsf-color-neutral-0))");
  } else {
    tooltip.style.setProperty("--dsf-arrow-border-color", "rgba(var(--dsf-color-neutral-700))");
    tooltip.style.setProperty("--dsf-arrow-color", "rgba(var(--dsf-color-neutral-700))");
  }
};
export {
  getTooltipClasses,
  updateCSSVariables
};
